var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "purchase-amount-noti"
  }, [_c('p', [_vm._v("※구매하신 상품권은 취소교환이 어려우니 신중히 확인하고 구매해주세요")]), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "pa-0",
          attrs: {
            "text": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 교환환불정책 ")])];
      }
    }]),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" 교환 환불 정책 ")]), _c('v-card-text', {
    staticClass: "purchase-amount-noti__info"
  }, [_c('p', [_vm._v("교환 환불을 원하시는 고객님께서는 help@daehanbooks.co.kr로 아래의 정보를 전달해주세요.")]), _c('ol', {
    staticClass: "purchase-amount-noti__list"
  }, [_c('li', [_vm._v(" 주민등록증 또는 운전면허증 "), _c('br'), _c('small', [_vm._v(" (뒷자리 가린 이미지) ")])]), _c('li', [_vm._v(" 통장 사본 이미지 ")]), _c('li', [_vm._v(" 아이디 ")]), _c('li', [_vm._v(" 결제금액 및 권종 ")])]), _c('p', [_vm._v("※ 환불시 소비자 보호법에 의거하여10% 수수료를 제외하고 환불 됩니다.")]), _c('p', [_vm._v("※ 환불은 영업일 기준 2~3일 내에 보내주신 통장으로 수수료를 제외하고 입금됩니다.")])]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v(" 닫기 ")])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "purchase-amount-noti"
  }, [_vm._v(" 구매 불가시간: 23:20~24:40(은행 점검시간) ")]), _c('div', {
    staticClass: "purchase-amount-noti"
  }, [_vm._v(" 발송 된 핀은 구매자 외 충전 및 사용 불가 ")]), _c('paysolus-notice', {
    staticClass: "mt-16px text-center"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }